import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FormattedMessage } from 'react-intl';
import Conf from '../../../config/config.js';


const styles = theme => ({
  root: {
    textAlign: 'center',
    flexDirection: 'column',
    padding: '35px 10px 16px 10px',
    backgroundColor: '#fafafa',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',   
  },
  root2: {
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    margin: '10px',
  },
  button: {
    textAlign: 'center',
    marginTop: '20px',
    width: '60%',
    maxWidth: '300px',
  },
  typography: {
    margin: '10px 0 0 5px',
    fontSize: '0.8em'
  },
  typographySec: {
    textAlign: 'left',
    color: "#d50000",
    border: "solid 2px #d50000",
    margin: '20px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.2em",
    fontSize: "1.0em",
  },
  typographyText: {
    textAlign: 'left',
    margin: '5px 10px 0 16px',
    fontSize: '0.8em'
  },
  conf: {
    paddingRight: "127px",
    },
  conf2: {
    paddingRight: "18px",
  },
  conf3: {
    paddingRight: "100px",
  },
});

const ExPanelSummary = withStyles(theme => ({
  root: {
    padding: '5px 5px 5px 10px !important',
    height: '18px',
    backgroundColor: "#c6e2ff",
    minHeight: "45px",
      '&$expanded': {
        minHeight: "45px",
      },
  },
  expanded: {
    padding: "12px 0 12px 0px"
  },
  expandIcon: {
    padding: "0",
  }
}))(ExpansionPanelSummary);

const ExPanel = withStyles(theme => ({
  root: {
    fontSize: "1.0em"
  },
  expanded: {
    margin: "0"
  },
}))(ExpansionPanel);

const ExPanelDetail = withStyles(theme => ({
  root: {
    padding: "0 10px 10px 10px",
    display: "block",
  }
}))(ExpansionPanelDetails);

class ImportantPage extends React.Component {
  state = { checkFlgs : [false, false, false, false, false] };
  setValue = (val) => {
    let { checkFlgs } = this.state;
    checkFlgs[val] = true;
    this.setState({checkFlgs: checkFlgs});
  }

  onClickNext = () => {
    this.props.history.push('/workRequestSeparation');
  };

  onClickBack = () => {
    this.props.history.push('/workMenu');
  };

render() {
    const { classes } = this.props;
    const { checkFlgs } = this.state;
    for (const checkFlg of checkFlgs) {
      if (!checkFlg) break;
    }
    return (
    <div className={classes.root}>
      <form noValidate autoComplete="off" className={classes.root}>
        <Typography variant="subtitle2" className={classes.typographySec}><span><FormattedMessage id={'importantPage.message.confirm'}/></span></Typography>
        <Typography className={classes.typographyText}><font color="#d50000">次の事項は，引込線等切離に係わる事項です。特に【必須】となっている項目については重要事項のため必ずご確認ください。</font></Typography>
        <Grid container >
          <Grid item xs={12} md={12}>
            <Card className={classes.root2}>
              <ExPanel >
                <ExPanelSummary expandIcon={<ExpandMoreIcon />} onClick={()=>this.setValue(0)}>
                  <Typography><font color="#d50000">【必須】</font>必要な費用負担（作業・調査・申請・キャンセル）</Typography>
                </ExPanelSummary>
                <ExPanelDetail >
                  <Typography className={classes.typography}>　引込線切離サービスは，沖縄電力株式会社の託送供給等約款62（引込線の接続）にもとづく引込線の切離しおよび接続について，沖縄電力株式会社から委託を受けて沖電企業配電サポートセンターが受付いたします。</Typography>
                  <Typography className={classes.typography}>　引込線切離サービス契約にもとづき申し受ける引込線切離サービス料金は，引込線の切離しと接続分をあわせたもので，その内訳は「サービス基本料金」「加算料金」および申請費用などの「実費」の合計となります。</Typography>
                  <Typography className={classes.typography}>　引込線切離サービス料金の詳細は，申込み後に見積書にてお知らせします。</Typography>
                  <Typography className={classes.typography}>　なお，取付けに必要な資材代は「加算料金」に含まれています。</Typography>
                  <p style={{fontSize: 5, height: 15}}></p>
                  <Typography className={classes.typography}>　キャンセルについては，申込受付後，既に実施した調整や諸手配等の実働がある場合に，キャンセル料として申し受ける場合があります。</Typography>
                  <p style={{fontSize: 5, height: 15}}></p>
                  <Typography className={classes.typography}>　引込線切離サービス料金は，三井住友カード株式会社に債権譲渡します。作業完了後に，三井住友カード株式会社より請求させていただきます。</Typography>
                  <Typography className={classes.typography}>　振込手数料は、申込者で負担をお願いします。</Typography>
                </ExPanelDetail>
              </ExPanel>
              <ExPanel >
                <ExPanelSummary expandIcon={<ExpandMoreIcon />} onClick={()=>this.setValue(1)}>
                  <Typography><font color="#d50000">【必須】</font>災害時・悪天候時のやむを得ない作業予定日の延期</Typography>
                </ExPanelSummary>
                <ExPanelDetail >
                  <Typography className={classes.typography}>　強風・雷雨等の天候事情などにより，やむを得ず作業予定を延期させていただくことがあります。</Typography>
                </ExPanelDetail>
              </ExPanel>
              <ExPanel >
                <ExPanelSummary expandIcon={<ExpandMoreIcon />} onClick={()=>this.setValue(3)}>
                  <Typography><font color="#d50000">【必須】</font>契約に係る事前のお知らせ事項</Typography>
                </ExPanelSummary>
                <ExPanelDetail>
                  <Typography className={classes.typography}>１．引込線切離サービス契約の成立</Typography>
                  <Typography className={classes.typography}>この入力用システムの「お見積金額確認」画面において，「見積金額明細」および「約款」を確認いただいたうえで，「承諾」ボタンを押していただくことで契約成立となります。</Typography>
                  <p style={{fontSize: 5, height: 15}}></p>
                  <Typography className={classes.typography}>２．引込線切離しおよび接続の日程</Typography>
                  <Typography className={classes.typography}>事業者さまの希望に沿うよう作業日等を調整いたしますが，やむを得ず作業希望日に実施できない場合がありますので，予めご了承ください。</Typography>
                  <p style={{fontSize: 5, height: 5}}></p>
                  <Typography className={classes.typography}>（作業希望日に作業が実施できない場合の例）</Typography>
                  <Typography className={classes.typography}>・契約成立から，１カ月半程度の期間が確保されていない場合</Typography>
                  <Typography className={classes.typography}>・作業場所により，作業に必要な申請等を実施する必要がある場合</Typography>
                  <Typography className={classes.typography}>・自然災害・悪天候により，計画した作業日に作業ができない場合    など</Typography>
                  <p style={{fontSize: 5, height: 15}}></p>
                  <Typography className={classes.typography}>３．キャンセル料</Typography>
                  <Typography className={classes.typography}>事業者さまからの申込みを受付後，引込線切離しに向けた調整を開始するため，以後のキャンセルにおいては，キャンセル料を申し受ける場合があります。</Typography>
                  <p style={{fontSize: 5, height: 15}}></p>
                  <Typography className={classes.typography}>４．取付作業時の申込者さまの立会</Typography>
                  <Typography className={classes.typography}>作業日が決まりましたら，メールにてお知らせします。引込線の切離しおよび接続の際は立会をお願いいたします。</Typography>
                </ExPanelDetail>
              </ExPanel>
              <ExPanel >
                <ExPanelSummary expandIcon={<ExpandMoreIcon />} onClick={()=>this.setValue(4)}>
                  <Typography><font color="#d50000">【必須】</font>作業に伴い申請書を提出する場合の準備期間</Typography>
                </ExPanelSummary>
                <ExPanelDetail>
                  <Typography className={classes.typography}>　引込線切離し作業作業を実施するにあたり，道路管理者への申請等が必要な場合は通常の作業準備期間（３週間程度）に加え，申請書作成～申請許可に要する期間として少なくとも一カ月程度を必要としますので，ご理解をお願いします。</Typography>
                  <Typography className={classes.typography}>　なお，事業者さまで確保される作業用エリア内に，作業車等を配置して作業を行うことも可能な場合がありますので，申込み時にご相談ください。</Typography>
                </ExPanelDetail>
              </ExPanel>
            </Card>
          </Grid>
          <Grid item xs={12} md={12}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              size="large"
              disabled={false}
              onClick={this.onClickNext}
            >
              <span>次へ(上記に同意)</span>
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              size="large"
              onClick={this.onClickBack}
            >
              <span><FormattedMessage id={'common.btn.back'}/></span>
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div style={{margin:"10px 0 20px 0"}}>
              <Typography className={classes.conf} align="right" >　<span><FormattedMessage id={'importantPage.contact'}/></span></Typography>
              <Typography className={classes.conf2} align="right" >　<span>{Conf.company}</span>　配電サポートセンター</Typography>
              <Typography className={classes.conf3} align='right'>　<span>(電話番号)　{Conf.tell}</span></Typography>
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
    );
  }
}

ImportantPage.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};
export default withStyles(styles)(ImportantPage);
